import React, { useState } from "react";
import styled from "styled-components";

import { Section } from "../../components/shared/layout/Layout";
import Subtitle from "../../components/shared/text/Subtitle";
import { smMedia } from "../../utils/getMediaStyle";
import Button from "../Button";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.color.background.contentBreaker};
  padding: 120px 160px;
  ${smMedia`
    width: 100vw;
    overflow:hidden;
    padding: 60px 32px;
  `}
`;
const TabContent = styled(Section)`
  height: 600px;
  width: 100%;
  background: #c4c4c4;
  ${smMedia`
    height: 385px;
  `}
`;
const ButtonText = styled.span`
  font-size: 18px;
  ${smMedia`
    font-size: 14px;
  `}
`;
const Examples = (props) => {
  const [activeTab, setActiveTab] = useState(1);
  return (
    <Container className="d-flex flex-column" {...props}>
      <Subtitle size={60} smSize={28}>
        Tailored to your role
      </Subtitle>
      <Section className="flex-space-between mb-5 mt-5 w-100 pl-0 pr-0 pl-md-4 pr-md-4">
        <Button
          className="col-4 col-md-2"
          variation={activeTab !== 0 ? "unselected" : ""}
          onClick={() => {
            setActiveTab(0);
          }}
        >
          <ButtonText>Executives</ButtonText>
        </Button>
        <Button
          className="col-4 col-md-2"
          variation={activeTab !== 1 ? "unselected" : ""}
          onClick={() => {
            setActiveTab(1);
          }}
        >
          <ButtonText>Marketing</ButtonText>
        </Button>
        <Button
          className="col-4 col-md-2"
          variation={activeTab !== 2 ? "unselected" : ""}
          onClick={() => {
            setActiveTab(2);
          }}
        >
          <ButtonText>Agencies</ButtonText>
        </Button>
      </Section>
      {activeTab === 0 && <TabContent>Tab1</TabContent>}
      {activeTab === 1 && <TabContent>Tab2</TabContent>}
      {activeTab === 2 && <TabContent>Tab3</TabContent>}
    </Container>
  );
};

export default Examples;
